export const SESSION_STORAGE_KEY = 'task-hub.session';
const FOCUS_TIMER_STORAGE_PREFIX = 'task-hub.focus-timer';
const FOCUS_VIEW_STORAGE_PREFIX = 'task-hub.focus-view';

export function readStoredSession() {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.user?.id) return null;
    return parsed;
  } catch (_error) {
    return null;
  }
}

export function persistSession(session) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearStoredSession() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
}

function getFocusTimerStorageKey(userId) {
  return `${FOCUS_TIMER_STORAGE_PREFIX}.${userId}`;
}

function getFocusViewStorageKey(userId) {
  return `${FOCUS_VIEW_STORAGE_PREFIX}.${userId}`;
}

export function readStoredFocusTimer(userId) {
  if (typeof window === 'undefined' || !userId) return null;

  try {
    const raw = window.localStorage.getItem(getFocusTimerStorageKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

export function persistStoredFocusTimer(userId, timer) {
  if (typeof window === 'undefined' || !userId) return;
  window.localStorage.setItem(getFocusTimerStorageKey(userId), JSON.stringify(timer));
}

export function clearStoredFocusTimer(userId) {
  if (typeof window === 'undefined' || !userId) return;
  window.localStorage.removeItem(getFocusTimerStorageKey(userId));
}

export function readStoredFocusView(userId) {
  if (typeof window === 'undefined' || !userId) return null;

  try {
    const raw = window.localStorage.getItem(getFocusViewStorageKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

export function persistStoredFocusView(userId, view) {
  if (typeof window === 'undefined' || !userId) return;
  window.localStorage.setItem(getFocusViewStorageKey(userId), JSON.stringify(view));
}

export function clearStoredFocusView(userId) {
  if (typeof window === 'undefined' || !userId) return;
  window.localStorage.removeItem(getFocusViewStorageKey(userId));
}
